<template>
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
  >
    <path d="M2.24664 0C1.14207 0 0.246643 0.895431 0.246643 2V12C0.246643 13.1046 1.14207 14 2.24664 14H8.24664C9.35121 14 10.2466 13.1046 10.2466 12V4.41421C10.2466 4.01639 10.0886 3.63486 9.8073 3.35355L6.89309 0.43934C6.61178 0.158035 6.23025 0 5.83243 0H2.24664ZM1.24664 2C1.24664 1.44772 1.69436 1 2.24664 1H5.24664V3.5C5.24664 4.32843 5.91822 5 6.74664 5H9.24664V12C9.24664 12.5523 8.79893 13 8.24664 13H2.24664C1.69436 13 1.24664 12.5523 1.24664 12V2ZM9.03954 4H6.74664C6.4705 4 6.24664 3.77614 6.24664 3.5V1.20711L9.03954 4Z" />
  </svg>
</template>
